(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  'use strict';
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency || 'USD'}).format(Number(cents)/100);
  const rootURL = root => root.endsWith('/') ? root : root + '/';
  const closeMenu = () => {
    const button=document.querySelector('.menu-toggle'),menu=document.getElementById('mobile-menu');
    if(button)button.setAttribute('aria-expanded','false');
    if(menu)menu.hidden=true;
  };
  const initializeMenu = scope => {
    const button=scope.querySelector('.menu-toggle');
    if(!button || button.dataset.ready)return;
    button.dataset.ready='true';
    const menu=document.getElementById('mobile-menu');
    button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));menu.hidden=!open;});
    menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
  };
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closeMenu();});
  let lastFocus;
  const openBag = async root => {
    const response=await fetch(rootURL(root)+'cart.js',{headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('cart');
    const cart=await response.json();
    const drawer=document.getElementById('bag-drawer');
    if(!drawer || typeof drawer.showModal!=='function'){window.location.assign(rootURL(root)+'cart');return;}
    const container=drawer.querySelector('[data-bag-items]');
    container.replaceChildren();
    for(const item of cart.items){
      const node=drawer.querySelector('[data-bag-item]').content.cloneNode(true);
      const image=node.querySelector('img');
      if(item.image){image.src=item.image;image.alt=item.product_title || item.title;}else image.remove();
      const link=node.querySelector('[data-item-link]');link.textContent=item.product_title || item.title;link.href=item.url;
      node.querySelector('[data-item-variant]').textContent=item.variant_title==='Default Title'?'':item.variant_title || '';
      node.querySelector('[data-item-quantity]').textContent=item.quantity;
      node.querySelector('[data-item-price]').textContent=money(item.final_line_price,cart.currency);
      container.append(node);
    }
    document.querySelectorAll('[data-count]').forEach(el=>el.textContent=cart.item_count);
    drawer.querySelector('[data-bag-total]').textContent=money(cart.total_price,cart.currency);
    drawer.querySelector('[data-bag-error]').textContent='';
    lastFocus=document.activeElement;
    if(!drawer.open)drawer.showModal();
    drawer.querySelector('[data-close-bag]').focus();
  };
  const initializeProduct = scope => {
    const products=scope.matches?.('[data-product]')?[scope]:scope.querySelectorAll('[data-product]');
    products.forEach(section=>{
      if(section.dataset.ready)return;
      const form=section.querySelector('.product-form'),native=section.querySelector('[data-native-variant]'),picker=section.querySelector('.set-picker'),mix=section.querySelector('[data-mix-selects]'),add=section.querySelector('[name=add]');
      if(!form||!native||!picker||!mix||!add)return;
      section.dataset.ready='true';
      let busy=false;
      const options=Array.from(native.options).map(option=>({id:option.value,title:option.textContent.trim(),price:Number(option.dataset.price),media:option.dataset.media,available:!option.disabled}));
      const selected=options.find(option=>option.id===native.value && option.available)||options.find(option=>option.available)||options[0];
      const currency=section.dataset.currency;
      const setRadios=Array.from(section.querySelectorAll('[name=chef_set]'));
      const count=()=>Number(setRadios.find(radio=>radio.checked)?.value||1);
      const selections=()=>Array.from(mix.querySelectorAll('select')).map(select=>options.find(option=>option.id===select.value));
      const showMedia=id=>{
        if(!id || !Array.from(section.querySelectorAll('[data-panel]')).some(panel=>panel.dataset.panel===id))return;
        section.querySelectorAll('[data-panel]').forEach(panel=>{panel.hidden=panel.dataset.panel!==id;if(panel.hidden)panel.querySelectorAll('video').forEach(video=>video.pause());});
        section.querySelectorAll('[data-media]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.media===id)));
      };
      const update=()=>{
        const values=selections(),valid=values.length===count()&&values.every(v=>v&&v.available),total=values.reduce((sum,v)=>sum+(v?.price||0),0);
        const formatted=money(total,currency);
        section.querySelector('[data-price]').textContent=formatted;
        section.querySelector('[data-sticky-price]').textContent=formatted;
        section.querySelector('[data-selection]').textContent=values.filter(Boolean).map(v=>v.title).join(' + ');
        add.disabled=busy||!valid;
        section.querySelector('[data-button-copy]').textContent=busy?section.dataset.adding:valid?section.dataset.add:section.dataset.soldOut;
        if(values[0]){native.value=values[0].id;const url=new URL(window.location.href);url.searchParams.set('variant',values[0].id);history.replaceState({},'',url);}
        section.querySelectorAll('[data-set-total]').forEach(el=>el.textContent=money((values[0]?.price||selected?.price||0)*Number(el.dataset.setTotal),currency));
      };
      const render=()=>{
        const previous=selections();mix.replaceChildren();
        for(let i=0;i<count();i++){
          const label=document.createElement('label'),caption=document.createElement('span'),select=document.createElement('select');
          caption.textContent=count()===1?section.dataset.select:section.dataset.item+' '+(i+1);
          select.setAttribute('aria-label',caption.textContent);select.required=true;
          options.forEach(value=>{const option=document.createElement('option');option.value=value.id;option.textContent=value.title;option.disabled=!value.available;select.append(option);});
          select.value=previous[i]?.available?previous[i].id:previous[0]?.available?previous[0].id:selected?.id||'';
          select.addEventListener('change',()=>{section.querySelector('[data-product-error]').textContent='';showMedia(options.find(o=>o.id===select.value)?.media);update();});
          label.append(caption,select);mix.append(label);
        }
        update();
      };
      picker.hidden=false;section.querySelector('.native-picker').hidden=true;
      setRadios.forEach(radio=>radio.addEventListener('change',render));
      section.querySelectorAll('[data-media]').forEach(button=>button.addEventListener('click',()=>showMedia(button.dataset.media)));
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(busy)return;
        const chosen=selections();if(chosen.length!==count()||chosen.some(v=>!v||!v.available)){update();return;}
        const counts=new Map();chosen.forEach(v=>counts.set(v.id,(counts.get(v.id)||0)+1));
        const items=Array.from(counts,([id,quantity])=>({id,quantity}));
        busy=true;update();const error=section.querySelector('[data-product-error]');error.textContent='';
        let added=false;
        try{
          const root=rootURL(section.dataset.root||'/');
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||result.message||section.dataset.error);
          added=true;await openBag(root);
        }catch(exception){
          if(added){window.location.assign(rootURL(section.dataset.root||'/')+'cart');return;}
          error.textContent=exception.message||section.dataset.error;
        }finally{busy=false;update();}
      });
      render();
      const sticky=section.querySelector('.sticky-purchase');
      if(sticky&&'IntersectionObserver' in window){
        const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||add.getBoundingClientRect().top>0;},{rootMargin:'-80px 0px 0px 0px'});observer.observe(add);
      }
    });
  };
  const init = (scope=document) => {initializeMenu(scope);initializeProduct(scope);};
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  const drawer=document.getElementById('bag-drawer');
  if(drawer){drawer.querySelector('[data-close-bag]').addEventListener('click',()=>drawer.close());drawer.addEventListener('close',()=>lastFocus?.focus());drawer.addEventListener('click',event=>{if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)drawer.close();}});}
})();


  } catch(e) { console.error(e); }
})();
})();
